module.exports = __webpack_public_path__ + "img/lc.460c25b1.svg";